// extracted by mini-css-extract-plugin
export default {"sentence":"Sentence_sentence__DsPAO","appear":"Sentence_appear__b2Z+4","text":"Sentence_text__hna7+","signature":"Sentence_signature__dQj7h"};